import Vue from 'vue'
import router from '@/router'
import utils from '@/utils'
import api from '@/api/index'
import config from '@/config/index'

const state = {
  //
}

const actions = {
  getCode (store, phone) { // 获取找回密码手机验证码
    api.get(config.bylBaseCenterPath, '/findPassword/phone/code', {
      phone: phone
    }, function (r) { // 获取正常
      Vue.toasted.show('获取验证码成功')
    })
  },
  validatePhone (store, f) { // 验证手机号是否注册,并重置密码
    api.post(config.bylBaseCenterPath, '/findPassword/validate-phone', {
      phone: f.phone,
      code: f.code,
      password: f.password
    }, function (r) {
      Vue.toasted.show('重置密码成功')
      var domain = utils.getQueryString('domain')
      if (utils.getQueryString('h')) {
        window.location.href = window.location.origin + '/#/byl/login?h=' + utils.getQueryString('h') + '&domain=' + domain
      } else {
        router.push({path: '/byl/login'})
      }
    })
  }
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pwd-reset.js